export enum ContentSize {
    Small = 'small',
    Normal = 'normal',
    Medium = 'medium',
    Large = 'large',
    XLarge = 'xlarge',
    Full = 'full',
}
